import { amnioReqData } from '@/store'

// Stores amnio_required_data in its own IDB store.
// No encryption since it doesn't contain PHI.
export async function extractAndStoreAmnioData(patient) {
  const amnioRequiredDataByWoundId = {}

  patient.wounds = (patient.wounds || []).map(wound => {
    if (wound.amnio_required_data) {
      amnioRequiredDataByWoundId[wound.id] = wound.amnio_required_data
    }

    const { amnio_required_data, ...cleanWound } = wound
    return cleanWound
  })

  for (const [woundId, amnioData] of Object.entries(amnioRequiredDataByWoundId)) {
    await amnioReqData.setItem(woundId, amnioData)
  }

  return patient // now cleaned of amnio_required_data
}


// ✅ Add item to array inside a wound's stored data
export async function addTreatmentToReservedData(woundId, newTreatment) {
  let data = await amnioReqData.getItem(woundId)

  if (!Array.isArray(data)) {
    data = []
  }

  const index = data.findIndex(t => t.treatment_id === newTreatment.treatment_id)

  if (index !== -1) {
    // Overwrite existing treatment
    data[index] = newTreatment
  } else {
    // Add new treatment
    data.push(newTreatment)
  }

  await amnioReqData.setItem(woundId, data)
}


// ❌ Remove a treatment by treatment_id
export async function removeTreatmentFromReservedData(woundId, treatmentIdToRemove) {
  const data = await amnioReqData.getItem(woundId)

  if (Array.isArray(data)) {
    const updated = data.filter(item => item.treatment_id !== treatmentIdToRemove)
    await amnioReqData.setItem(woundId, updated)
  }
}
